import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";
import { FAQ } from "../content";
import { Reveal } from "../lib/motion";

export const Faq = () => (
  <section
    id="faq"
    data-testid="faq-section"
    className="on-light bg-creme text-tinta py-20 md:py-28"
  >
    <div className="max-w-4xl mx-auto px-5 sm:px-8">
      <Reveal>
        <p className="label-caps text-azul mb-5">Perguntas frequentes</p>
        <h2
          data-testid="faq-title"
          className="headline text-3xl sm:text-4xl lg:text-5xl"
        >
          Direto ao ponto
        </h2>
      </Reveal>

      <Reveal delay={0.1}>
        <Accordion type="single" collapsible className="mt-10 md:mt-12">
          {FAQ.map((item, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              className="border-b border-creamline"
            >
              <AccordionTrigger
                data-testid={`faq-question-${i}`}
                className="font-sora font-bold text-left text-base md:text-lg tracking-[-0.025em] py-6 hover:text-azul hover:no-underline transition-colors duration-150"
              >
                {item.q}
              </AccordionTrigger>
              <AccordionContent
                data-testid={`faq-answer-${i}`}
                className="text-mutedlight text-sm md:text-base leading-relaxed pb-6"
              >
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
